import {
  getCruiseCountriesByItinerary,
  getCruisePortsByItinerary,
} from 'lib/cruises/cruiseUtils'
import { compactLines } from './message'

export function buildCruiseOfferDrawerContext(offer: App.CruiseOffer): string {
  const ports = getCruisePortsByItinerary(offer.itinerary)
  const countries = getCruiseCountriesByItinerary(offer.itinerary)
  const summaryDescription = offer.ship.shipInfo?.find(
    (info) => info.dataTypeName === 'Summary',
  )?.description
  const offerDescription =
    offer.description || summaryDescription || offer.destinationDescription

  return compactLines([
    'Drawer: Cruise offer',
    `Offer ID: ${offer.id}`,
    `Cruise line: ${offer.cruiseLine.name}`,
    `Ship: ${offer.ship.name}`,
    `Duration: ${offer.duration} nights`,
    offer.departurePort && `Departure port: ${offer.departurePort}`,
    offer.returnPort && `Return port: ${offer.returnPort}`,
    offer.cruiseType && `Cruise type: ${offer.cruiseType}`,
    ports.length > 0 && `Ports visited: ${ports.join(', ')}`,
    countries.length > 0 && `Countries visited: ${countries.join(', ')}`,
    offerDescription && `Description: ${offerDescription}`,
  ])
}
